import {useState} from "react";

const WithInputValidations = (props) => {

  const {children} = props;

  const [inputsValidated, setInputsValidated] = useState(true);

  const updateInputValidations = () => {
    setInputsValidated(false);
    return new Promise((resolve) => {
      setTimeout(() => {
        setInputsValidated(false);
        resolve()
      }, 300); // wait until redux store is updated with input Errors
    });
  };

  return children(inputsValidated, updateInputValidations)
};

export default WithInputValidations
